import { Button } from '@material-ui/core';
import React, { useRef, useState} from 'react';


import 'react-toastify/dist/ReactToastify.css';

import TextField from '@material-ui/core/TextField';





import MUIDataTable from "mui-datatables";





export default function HttpStatus() {


  const json = useRef()
  const [datatableData3,setdatatableData3] = useState([]);

function Check()
{
      var content = json.current.value;
      var content_split = content.split(/\n|,/g);
      var MainUrl = 'https://mobileappscrapper.herokuapp.com/statusx/'
      console.log(content_split);
      for (const value of content_split) {
        fetch(MainUrl + value)
          .then(res => res.json())
          .then(data => {
            setdatatableData3(prev => [...prev, [value, data]]);
          })
          .catch(() => {
            setdatatableData3(prev => [...prev, [value, "No data"]]);
          });
      }
}
  



return (
    <div >
      <br></br>
       <TextField variant="outlined" multiline inputRef={json} rows={10} placeholder="Insert domain without prefixes like http:// or https:// separated by line break" id="tocheck" style={{borderRadius:"10px",textAlign:"center",width:"100%",height:"250px",resize:"vertical"}} className="inline-txtarea"></TextField>
     
<br></br>
    <br></br>
    <Button variant="contained" color="primary" onClick={Check}>Analyse</Button>
    <label htmlFor="upload-file">

</label><br></br>
    <p> </p>
    <MUIDataTable
            
            title="Http Status Analysis"
            columns={["Domain", "Status"]}
            data={datatableData3}
            options={{
              filterType: "checkbox",
              downloadOptions: {
                filename: 'HttpStatus_' + new Date().toISOString().slice(0, 10) + '.csv',
                filterOptions: {
                  useDisplayedColumnsOnly:true
                }
              },
              sort: true,
              sortDirection: 'desc',
              textLabels: {
                body: {
                  noMatch: "Please analyse Bid Requests first",
                }},
            }}
            
          />
<div>
</div>
    </div>
    
);
}
